import auth from './auth';

export default {
  state: {
    lang: {},
    user: null,
    changelog: {}
  },
  mutations: {
    login(state, user) {
      state.user = user;
      // console.log(state.user.metadata.length);
      /* if(state.user.metadata.length == 0){

        state.user.metadata = metadata;
      } else {
      }
      console.log("---users---", state.user); */
    },
    logout(state) {
      state.user = null;
    },
    setLang(state, lang) {
      state.lang = { ...state.lang, ...lang };
    },
    updateUserMetadata(state, metadata) {
      auth.updateMeta(metadata);
      state.user = auth.authenticatedUser();
    },
    setQuickLinks(state, links) {
      auth.updateMetadata(links);
      state.user = auth.authenticatedUser();
    },
    setChangelog(state, log) {
      state.changelog = log;
    }
  },
};
